import script from "./SelectInputRemote.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInputRemote.vue?vue&type=script&setup=true&lang=js"

import "./SelectInputRemote.vue?vue&type=style&index=0&id=c9a06d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9a06d40"]])

export default __exports__